import React from "react";
// @ts-expect-error - TS2314 - Generic type 'RefObject<T>' requires 1 type argument(s).
const useDropdown = (ref) => {
    const [isOpen, setIsOpen] = React.useState(false);
    React.useLayoutEffect(() => {
        $(ref.current).dropdown();
        // This didn't include ref when I updated the file and I don't want to break this.
        // eslint-disable-next-line
    }, []);
    React.useEffect(() => {
        const jqueryRef = $(ref.current);
        const menuRef = jqueryRef.siblings(".dropdown-menu").last();
        // Figure out if the value of isOpen matches whether the dropdown is really open.
        if ((menuRef === null || menuRef === void 0 ? void 0 : menuRef.hasClass("show")) !== isOpen) {
            jqueryRef.dropdown("toggle");
        }
    }, [isOpen, ref]);
    React.useEffect(() => {
        const jqueryRefVal = $(ref.current);
        jqueryRefVal.on("shown.bs.dropdown", () => setIsOpen(true));
        jqueryRefVal.on("hidden.bs.dropdown", () => setIsOpen(false));
        return () => {
            jqueryRefVal.off("shown.bs.dropdown");
            jqueryRefVal.off("hidden.bs.dropdown");
        };
    });
    return [isOpen, setIsOpen];
};
export default useDropdown;
